import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

import { ItemPrice } from './ItemPrice';
import { OrderItemType } from '@global/utils/orderUtils';
import { Discount } from '@global/types/types';
import { DEFAULT_IMAGE } from '@src/global/App/constants/constants';

interface OrderItemProps {
  orderItem: OrderItemType;
  discount?: Discount;
  isSubscription?: boolean;
}

export const OrderItem: FC<OrderItemProps> = ({
  orderItem,
  discount,
  isSubscription,
}) => {
  const { t } = useTranslation('', {
    keyPrefix: 'checkout.review.productInfo',
  });

  const handleImageError = () => {
    setImgSrc(DEFAULT_IMAGE);
  };

  const [imgSrc, setImgSrc] = useState(orderItem.imageUrl || DEFAULT_IMAGE);

  return (
    <div className="order-item">
      <div
        className={`order-item__image${
          imgSrc === DEFAULT_IMAGE ? '__default' : ''
        }`}
      >
        <img
          src={imgSrc}
          alt="Wiley Book Cover"
          loading="lazy"
          onError={handleImageError}
        />
      </div>
      <div className="order-item__content">
        <div className="order-item__header">
          <div className="order-item__title">{orderItem.maName}</div>
        </div>
        <div className="order-item__info">
          <strong className="order-item__info--bold">{t('format')}</strong>{' '}
          {orderItem.category}
        </div>
        {!isSubscription && (
          <div className="order-item__info">
            <strong className="order-item__info--bold">
              {t('instructors')}
            </strong>{' '}
            {orderItem.authors.join(', ')}
          </div>
        )}
        <div className="order-item__info">
          <strong className="order-item__info--bold">{t('qty')}</strong>{' '}
          {orderItem.qty}
        </div>
        <ItemPrice
          discount={discount}
          price={orderItem.price}
          priceBeforeDiscount={orderItem.priceBeforeDiscount}
        />
      </div>
      <ItemPrice
        discount={discount}
        price={orderItem.price}
        priceBeforeDiscount={orderItem.priceBeforeDiscount}
      />
    </div>
  );
};
